import React, { useState, useEffect } from 'react'
import { Menu, Flex, Button } from 'antd'
// import { useState } from 'react';
import styles from './hd.module.less'
import { UserOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';



export default function MyHeaderOne() {

    useEffect(() => {
        if (window.scrollY === 0) {
            setIsTop(true)
        } else {
            setIsTop(false)
        }
    }, [])

    const navigate = useNavigate();

    const toGo = (page) => {
        window.scrollTo(0, 0);
        navigate(page)
    }

    const items = [
        {
            key: 'index',
            label: <a onClick={() => toGo('/')}>首页</a>,
        },
        {
            key: 'kuaibao',
            label: <a onClick={() => toGo('/jckb')}>动态监测快报</a>,
        },
        {
            key: 'kycg',
            label: <a onClick={() => toGo('/kycg')} >学术研究成果</a>,
        },
        {
            key: 'hvpx',
            label: <a onClick={() => toGo('/xxfb')} >信息发布</a>,

        },
        {
            key: 'about',
            label: <a onClick={() => toGo('/about')} >关于我们</a>,
        },
    ];


    const defaultMenuKey = () => {
        switch (window.location.pathname) {
            case '/':
                return 'index'
            case '/jckb':
                return 'kuaibao'
            case '/kycg':
                return 'kycg'
            case '/xxfb':
                return 'hvpx'
            case '/about':
                return 'about'
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const [scroll, setScroll] = useState('up')
    const [isTop, setIsTop] = useState(true)



    useEffect(() => {
        const handleScroll = (event) => {
            if (window.scrollY === 0) {
                setIsTop(true)
            } else {
                setIsTop(false)
            }
            if (event.deltaY < 0) {
                setScroll('up')
            } else {
                setScroll('down')
            }
        };
        window.addEventListener('wheel', handleScroll);
        return () => {
            window.removeEventListener('wheel', handleScroll)
        };
    }, [])

    return (
        <Flex className={[(scroll === 'up' && (!isTop)) ? styles.warpper : styles.warpper_w, (scroll === 'up') ? styles.scrollUp : styles.scrollDown].join(' ')}>
            <Flex className={styles.main} justify='space-between' align='center'>
                <Flex><div className={styles.logo}></div></Flex>
                <Menu selectedKeys={[defaultMenuKey()]} className={styles.menu} theme='light' mode="horizontal" items={items} />
                <Flex vertical={false}>
                    {/* <Button onClick={() => toGo('/search')} className={styles.search} */}
                    <Button onClick={() => toGo('/search')} className={styles.search}
                        icon={<SearchOutlined theme="outline" size="18" style={{ color: (scroll === 'up' && (!isTop)) ? '#000000' : '#ffffff' }} />} />
                    {/* <Button className={styles.search}
                        icon={<UserOutlined theme="outline" size="18" style={{ color: (scroll === 'up' && (!isTop)) ? '#000000' : '#ffffff' }} />} /> */}
                    {/* <Avatar size={28} style={{ cursor: 'pointer' }} icon={<UserOutlined />} /> */}
                </Flex>
            </Flex>
        </Flex>
    )
}
